export function compareObjectsById(objA: { [key: string]: any }, objB: { [key: string]: any }): boolean {
    return objA?.id === objB?.id;
}
